export {
    PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME,
    PROVIDER_NAME,
    RegisterDetailsComponentOptions,
    SERVICE_NAME as SYSTEM_SERVICE_NAME,
    SERVICE_NAME,
    SystemService,
    SystemServiceProvider,
} from './system.service'


export {
    SYSTEM_TARGET_PROVIDER_NAME,
    SYSTEM_TARGET_SERVICE_NAME,
    SystemTargetServiceProvider,
    SystemTargetService,
} from './system.target.service'

export {
    SYSTEM_INTERNATIONALIZATION_PROVIDER_NAME,
    SYSTEM_INTERNATIONALIZATION_SERVICE_NAME,
    SystemInternationalizationService,
    SystemInternationalizationServiceProvider,
    Week,
    Day,
    Formatter
} from './system.internationalization.service'

export {
    SYSTEM_CONTEXT_LIST_SERVICE_NAME,
    SYSTEM_CONTEXT_LIST_SERVICE_PROVIDER_NAME,
    SystemContextListService,
    SystemContextListServiceProvider
} from './system.context-list.service'

export {
    $COMPILE_SERVICE_NAME,
    $ELEMENT_SERVICE_NAME,
    $INTERVAL_SERVICE_NAME,
    $Q_SERVICE_NAME,
    $ROOT_SCOPE_SERVICE_NAME,
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $STATE_SERVICE_PROVIDER_NAME,
    $TIMEOUT_SERVICE_NAME,
    $WINDOW_SERVICE_NAME,
    BOWSER_SERVICE_NAME,
    CreateEditResult,
    DetailsResult,
    DetailsOptions,
    Language,
    OpenDetailsOrModuleOptions,
} from "./system.service.interfaces";

export { SYSTEM_SERVICES_MODULE_NAME } from './system.services.module'
